export default __webpack_public_path__ + "static/media/hot_water.dee25530.svg";